import { Component, inject, Input, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-view-validations',
  standalone: false,
  templateUrl: './view-validations.component.html',
  styleUrl: './view-validations.component.less'
})
export class ViewValidationsComponent implements OnInit  {
  readonly nzModalData = inject(NZ_MODAL_DATA);  
  validationText : string = '';
  openQueries : any[] = [];

  constructor(private modalService: NzModalService) { }
  ngOnInit() {
    this.validationText = this.nzModalData.validationText;    
    this.openQueries   = this.nzModalData.openQueries;    
  }
  closeModal() {
    this.modalService.closeAll();
  }
}
